module.exports = __webpack_public_path__ + "static/media/phoneIconDark.317c7471.svg";